import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCsrfToken } from '../../utils/csrf';
import { FormData } from '../models/ModelRegister';

export function useRegister() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState<FormData>({
    firstName: '',
    lastName: '',
    gender: '',
    birthDate: '',
    age: '',
    street: '',
    houseNumber: '',
    complement: '',
    city: '',
    state: '',
    country: '',
    zipCode: '',
    countryCode: '',
    areaCode: '',
    phoneNumber: '',
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [error, setError] = useState('');
  const [showPasswords, setShowPasswords] = useState({
    password: false,
    confirmPassword: false
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    const dataToSend = {
      first_name: formData.firstName,
      last_name: formData.lastName,
      gender: formData.gender,
      birth_date: formData.birthDate,
      age: formData.age,
      street: formData.street,
      house_number: formData.houseNumber,
      complement: formData.complement,
      city: formData.city,
      state: formData.state,
      country: formData.country,
      zip_code: formData.zipCode,
      phone: `${formData.countryCode}${formData.areaCode}${formData.phoneNumber}`,
      email: formData.email,
      password: formData.password
    };

    try {
      const response = await fetch('/api/register/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': await getCsrfToken(),
        },
        body: JSON.stringify(dataToSend),
        credentials: 'include'
      });

      const data = await response.json();

      if (response.ok) {
        navigate('/login');
      } else {
        setError(data.error || 'Registration failed');
      }
    } catch (err) {
      setError('An error occurred during registration');
    }
  };

  return {
    formData,
    error,
    showPasswords,
    handleChange,
    handleSubmit,
    setShowPasswords
  };
}